import React, { useContext, useEffect, useState } from "react"
import DirectoryContext from "./state/context"
import Collapse from "@material-ui/core/Collapse"
import Slider from "@material-ui/core/Slider"
import { ReactComponent as Search } from "images/icon_search.svg"
import ConditionalWrap from "conditional-wrap"

const DirectoryFilters = (props) => {
  const context = useContext(DirectoryContext)
  const [dropdowns, setDropdowns] = useState({
    amountGranted: false,
    category: false,
    yearsFunded: false,
  })
  const [selectedCategories, setSelectedCategories] = useState({
    Libraries: false,
    "Parks, Trails & Green Spaces": false,
    "Arts & Culture": false,
    "Regional, Sports, and Civic Facilities": false,
    Transit: false,
  })
  const [yearsFunded, setYearsFunded] = useState({
    min: 0,
    max: new Date().getFullYear() - 1994,
  })
  const [amountGranted, setAmountGranted] = useState({
    min: "0",
    max: "50,000,000",
  })
  const [currentYear, setCurrentYear] = useState(false)
  const [nameOrZipCode, setNameOrZipCode] = useState("")
  const [windowWidth, setWindowWidth] = useState(0)
  const [openFilters, setOpenFilters] = useState(false)
  const { type } = props

  const categories = [
    "Libraries",
    "Parks, Trails & Green Spaces",
    "Arts & Culture",
    "Regional, Sports, and Civic Facilities",
    "Transit",
  ]

  useEffect(() => {
    window.addEventListener("resize", saveWindowWidth)
    document.addEventListener("load", saveWindowWidth())

    return () => {
      window.removeEventListener("resize", saveWindowWidth)
      document.removeEventListener("load", saveWindowWidth)
    }
  }, [])

  const saveWindowWidth = () => {
    setWindowWidth(window.innerWidth)
  }

  const toggleDropdown = (name) => {
    setDropdowns({
      ...dropdowns,
      [name]: !dropdowns[name],
    })
  }

  const clearCategories = () => {
    const updatedCategories = { ...selectedCategories }

    const keys = Object.keys(updatedCategories)
    for (const key of keys) {
      updatedCategories[key] = false
    }

    setSelectedCategories(updatedCategories)
    setFilters("categories", updatedCategories)
  }

  const resetSlider = (type) => {
    if (type === "years") {
      setYearsFunded({
        min: 0,
        max: new Date().getFullYear() - 1994,
      })

      const updatedFilters = { ...context.filters }
      delete updatedFilters.min_years
      delete updatedFilters.max_years
      context.updateFilters(updatedFilters)
    } else if (type === "amount") {
      setAmountGranted({
        min: 0,
        max: 50000000,
      })

      setCurrentYear(false)

      const updatedFilters = { ...context.filters, current_year: false }
      delete updatedFilters.min_amount
      delete updatedFilters.max_amount
      context.updateFilters(updatedFilters)
    }

    closeAllDropdowns()
  }

  const handleSliderChange = (type, value) => {
    if (type === "years") {
      setYearsFunded({
        min: value[0],
        max: value[1],
      })
    } else if (type === "amount") {
      setAmountGranted({
        min: value[0].toLocaleString(),
        max: value[1].toLocaleString(),
      })
    }
  }

  const setFilters = (name, value) => {
    const updatedFilters = { ...context.filters }

    if (name === "categories") {
      const selected = []

      const keys = Object.keys(value)
      for (const key of keys) {
        if (value[key]) {
          selected.push(key)
        }
      }

      updatedFilters[name] = selected
    } else if (name === "yearsFunded") {
      updatedFilters.min_years = value.min
      updatedFilters.max_years = value.max
    } else if (name === "amountGranted") {
      updatedFilters.min_amount = value.min
      updatedFilters.max_amount = value.max
      updatedFilters.current_year = currentYear
    } else {
      updatedFilters[name] = value
    }

    context.updateFilters(updatedFilters)
    closeAllDropdowns()
  }

  const searchByNameOrZipCode = (event) => {
    event.preventDefault()

    const updatedFilters = { ...context.filters }
    updatedFilters.zip = nameOrZipCode
    context.updateFilters(updatedFilters)
  }

  const clearNameOrZipCode = () => {
    setNameOrZipCode("")

    const updatedFilters = { ...context.filters }
    delete updatedFilters.zip
    context.updateFilters(updatedFilters)
  }

  const closeAllDropdowns = () => {
    const currentDropdowns = { ...dropdowns }
    const dropdownKeys = Object.keys(dropdowns)
    for (const key of dropdownKeys) {
      currentDropdowns[key] = false
    }
    setDropdowns(currentDropdowns)
  }

  const filters = [
    <React.Fragment key="categories">
      {type === "assets" && (
        <div className="filters__dropdown">
          <button
            type="button"
            onClick={() => toggleDropdown("category")}
            className={dropdowns.category ? "open" : ""}
          >
            Category
          </button>

          <div className="filters__options">
            <Collapse in={dropdowns.category}>
              <div className="filters__options__inner">
                <ul>
                  {categories.map((category) => (
                    <li key={category}>
                      <label className="filters__option">
                        <input
                          value={selectedCategories[category] || false}
                          checked={selectedCategories[category]}
                          type="checkbox"
                          onChange={() =>
                            setSelectedCategories({
                              ...selectedCategories,
                              [category]: !selectedCategories[category],
                            })
                          }
                        />
                        <span />
                        <span>{category}</span>
                      </label>
                    </li>
                  ))}
                </ul>

                <div className="filters__controls">
                  <button
                    type="button"
                    className="filters__control filters__control--clear"
                    onClick={() => clearCategories()}
                  >
                    Clear
                  </button>

                  <button
                    type="button"
                    className="filters__control filters__control--save"
                    onClick={() => setFilters("categories", selectedCategories)}
                  >
                    Save
                  </button>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      )}
    </React.Fragment>,

    <div className="filters__dropdown" key="amount">
      <button
        type="button"
        onClick={() => toggleDropdown("amountGranted")}
        className={dropdowns.amountGranted ? "open" : ""}
      >
        {type === "assets" ? "Amount Granted" : "Amount Received"}
      </button>

      <div className="filters__options">
        <Collapse in={dropdowns.amountGranted}>
          <div className="filters__options__inner">
            <Slider
              value={[
                parseInt(
                  typeof amountGranted.min === "string"
                    ? amountGranted.min.replace(/\D/g, "")
                    : amountGranted.min,
                ) || 0,
                parseInt(
                  typeof amountGranted.max === "string"
                    ? amountGranted.max.replace(/\D/g, "")
                    : amountGranted.max,
                ) || 0,
              ]}
              max={50000000}
              marks={[
                { value: 0, label: "0" },
                { value: 25000000, label: "25M" },
                { value: 50000000, label: "50M" },
              ]}
              onChange={(_, value) => handleSliderChange("amount", value)}
              step={1000}
            />

            <div className="filters__inputs filters__inputs--amount">
              <label>
                <span>MIN</span>
                <input
                  type="text"
                  value={amountGranted.min}
                  onChange={(event) => {
                    setAmountGranted({
                      ...amountGranted,
                      min: event.target.value,
                    })
                  }}
                />
              </label>

              <label>
                <span>MAX</span>
                <input
                  type="text"
                  value={amountGranted.max}
                  onChange={(event) => {
                    setAmountGranted({
                      ...amountGranted,
                      max: event.target.value,
                    })
                  }}
                />
              </label>
            </div>

            <div className="filters__checkbox">
              <div className="segmented-controller">
                <button
                  className={currentYear ? "" : "active"}
                  onClick={() => setCurrentYear(false)}
                >
                  Year to Date
                </button>
                <button
                  className={currentYear ? "active" : ""}
                  onClick={() => setCurrentYear(true)}
                >
                  Current Year
                </button>
              </div>
            </div>

            <div className="filters__controls">
              <button
                type="button"
                className="filters__control filters__control--clear"
                onClick={() => resetSlider("amount", true)}
              >
                Clear
              </button>

              <button
                type="button"
                className="filters__control filters__control--save"
                onClick={() => setFilters("amountGranted", amountGranted)}
              >
                Save
              </button>
            </div>
          </div>
        </Collapse>
      </div>
    </div>,

    <div className="filters__dropdown" key="years">
      <button
        type="button"
        onClick={() => toggleDropdown("yearsFunded")}
        className={dropdowns.yearsFunded ? "open" : ""}
      >
        Years Funded
      </button>

      <div className="filters__options">
        <Collapse in={dropdowns.yearsFunded}>
          <div className="filters__options__inner">
            <Slider
              value={[
                parseInt(yearsFunded.min) || 0,
                parseInt(yearsFunded.max) || 0,
              ]}
              max={new Date().getFullYear() - 1994}
              marks={[
                { value: 0, label: "0" },
                {
                  value: new Date().getFullYear() - 1994,
                  label: `${new Date().getFullYear() - 1994}`,
                },
              ]}
              onChange={(_, value) => handleSliderChange("years", value)}
            />

            <div className="filters__inputs">
              <label>
                <span>MIN</span>
                <input
                  type="number"
                  value={yearsFunded.min}
                  onChange={(event) => {
                    setYearsFunded({
                      ...yearsFunded,
                      min: event.target.value,
                    })
                  }}
                />
                <span className="readonly" aria-hidden="true">
                  {`${yearsFunded.min} yrs`}
                </span>
              </label>

              <label>
                <span>MAX</span>
                <input
                  type="number"
                  value={yearsFunded.max}
                  onChange={(event) => {
                    setYearsFunded({
                      ...yearsFunded,
                      max: event.target.value,
                    })
                  }}
                />
                <span className="readonly" aria-hidden="true">
                  {`${yearsFunded.max} yrs`}
                </span>
              </label>
            </div>

            <div className="filters__controls">
              <button
                type="button"
                className="filters__control filters__control--clear"
                onClick={() => resetSlider("years", true)}
              >
                Clear
              </button>

              <button
                type="button"
                className="filters__control filters__control--save"
                onClick={() => setFilters("yearsFunded", yearsFunded)}
              >
                Save
              </button>
            </div>
          </div>
        </Collapse>
      </div>
    </div>,

    <form
      className="filters__search"
      onSubmit={searchByNameOrZipCode}
      key="search"
    >
      <label>
        <span className="sr-only text-black">Search by Name or Zip Code</span>
        <input
          name="zip"
          type="text"
          placeholder="Search by Name or Zip Code"
          value={nameOrZipCode}
          onChange={(event) => setNameOrZipCode(event.target.value)}
        />
      </label>

      {nameOrZipCode && (
        <button type="button" onClick={clearNameOrZipCode}>
          Clear
        </button>
      )}

      <button type="submit">
        <span className="sr-only text-black">Search</span>
        <Search />
      </button>
    </form>,

    <label className="filters__toggle" key="toggle">
      <input
        type="checkbox"
        name="map"
        value={context.showMap}
        onClick={() => context.toggleMap()}
      />

      <span />

      <span>{context.showMap ? "Hide Map" : "Show Map"}</span>
    </label>,
  ]

  return (
    <div className="filters">
      <button
        className={`filters__open ${openFilters ? "filters__open--close" : ""}`}
        onClick={() => setOpenFilters(!openFilters)}
      >
        Filter Results
      </button>

      <ConditionalWrap
        condition={windowWidth < 1340}
        wrap={(children) => <Collapse in={openFilters}>{children}</Collapse>}
      >
        {filters}
      </ConditionalWrap>
    </div>
  )
}

export default DirectoryFilters
